export default __webpack_public_path__ + "static/signature1-725fe0902626bd2a8167dd2454eb6ee0.png";